export const createProductHistoryState = () => ({
  errors: null,
  history: null,
  loading: false,
});
